// extracted by mini-css-extract-plugin
export default {"-large":"Ie8aWxN3m9y6spq7VPwN","customInformationBox":"UUtBd7073BTDMfhn8vLQ","upgradeLink":"P6N4ksPsT5AizE6_5pjI"};